

export const getFlowsheet = (id, build) => {
    return fetch('/flowsheets/'+id+'/config?build='+build, {mode: 'cors'});
    /*return new Promise((resolve, reject) => { 
        resolve(data3);
    });*/
    
}; 

export const saveFlowsheet = (id, data) => {
    return fetch('/flowsheets/'+id+'/update', {
        method: 'POST', 
        mode: 'cors',
        body: JSON.stringify(data)
    });
}; 

export const resetFlowsheet = (id) => {
    return fetch('/flowsheets/'+id+'/reset', {
        method: 'GET', 
        mode: 'cors'
    });
}; 

export const unbuildFlowsheet = (id) => {
    return fetch('/flowsheets/'+id+'/unbuild', {
        method: 'GET', 
        mode: 'cors'
    });
}; 

export const selectOption = (id, data) => {
    return fetch('/flowsheets/'+id+'/select_option', {
        method: 'POST', 
        mode: 'cors',
        body: JSON.stringify(data)
    });
}; 

export const getLogs = () => {
    return fetch('/flowsheets/get_logs', {
        method: 'GET', 
        mode: 'cors'
    });
}

export const downloadLogs = () => {
    return fetch('/flowsheets/download_logs', {
        method: 'POST', 
        mode: 'cors'
    });
}

export const setProject = (project) => {
    return fetch('/flowsheets/set_project/'+project, {
        method: 'GET', 
        mode: 'cors'
    });
}